import DomPurify from 'dompurify';
import { TemplateFormGrid, TemplateFormMode } from '../interfaces/template-form';
import { TemplateRawForm } from '../interfaces/template-raw-form';
import { TemplateFormRenderExpressionFactory } from './templateFormRenderExpressionFactory';
import { TemplateFormFieldFactory } from './templateFormFieldFactory';

export function TemplateFormGridFactory(
  template: TemplateRawForm['template'],
  mode: TemplateFormMode
): TemplateFormGrid[] {
  const formGrids = template.groups.map<TemplateFormGrid>(group => ({
    id: group.type,
    order: group.order,
    fields: [],
    props: {
      isCollapsed: !!group.is_collapsed,
      isCollapsible: !!group.is_collapsible || 'is_collapsed' in group,
      title: DomPurify.sanitize(group.title || ''),
      subTitle: DomPurify.sanitize(group.sub_title || ''),
      renderExpression: TemplateFormRenderExpressionFactory(group.render_if)
    }
  }));

  template.fields.forEach(field => {
    const gridIndex = formGrids.findIndex(grid => grid.id === field.group.type);

    if (gridIndex >= 0) {
      formGrids[gridIndex].fields.push(TemplateFormFieldFactory(field, mode, template.metadata));
    }
  });

  formGrids
    .sort((a, b) => a.order - b.order)
    .forEach(grid => {
      grid.fields.sort((a, b) => a.order - b.order);
    });

  return formGrids;
}
